export default __webpack_public_path__ + "static/media/thumbnail.e7a7a4d0.webp";